/* eslint-disable prefer-destructuring */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable operator-assignment */
/* eslint-disable max-len */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable prefer-template */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/self-closing-comp */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import {
    CheckCircle,
    PlayCircleOutlineOutlined,
    MenuBookRounded
} from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
import LibraryAddCheckIcon from '@material-ui/icons/LibraryAddCheck';
import FormattedMessageWithClass from '../../../components/formattedMessageWithClass';
import Button from '../../../components/button';
import Modal from '../../../components/modal';
import Collapsible from '../../../components/collapsible/Collapsible';
import { TRAINING_MANAGEMENT_SECTION_DETAILS } from '../../../constants/RouterConstants';
import styles from './detail.module.scss';

function SectionsList(props) {
    const {
        match: { params },
        trainingData,
        trainingDraft,
        margin,
        actiontTrainingDraft,
        history,
        setPlaybackTimeSet,
        startTraining,
        isPublic,
        actionContentInfo
    } = props;

    const [open, setOpen] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [section_Id, setSectionId] = useState('');
    const [subSectcion_Id, setSubId] = useState('');
    const [flag, setFlag] = useState(false);
    let isFromTraningView;
    if (isPublic) {
        isFromTraningView = !params.trainingId;
    } else {
        isFromTraningView = !params.id;
    }
    const trainingId = params.trainingId;
    const sectionId = params.id || trainingData?.sections[0]?.id;
    const subSectionId = params.subId || trainingData?.sections[0]?.contents[0]?.id;
    const totalSections = trainingData?.sections.length || 0;
    let totalLectures = 0;
    const toggle=props.match.path.includes('auth');
    if (trainingData?.sections?.length > 0) {
        trainingData.sections.map((item) => {
            totalLectures = totalLectures + item.contents.length;
            return true;
        });
    }

    const checkContentIsCompleted = (sectionId, contentId) => (
        trainingDraft?.level_completion?.section_id?.includes(sectionId.toString())
        && trainingDraft?.level_completion?.content_id?.includes(contentId)
    );

    const showAlert = () => {
        setOpen(true);
    };

    const manageSectionRestricted = (sId) => {
        const section = trainingData?.sections.find(sec => sec.id === Number(sectionId));
        const isCompleted = section.contents.every(content => (trainingDraft?.level_completion?.content_id || []).includes(String(content.id)));
        const firstSection = !!(Object.keys(trainingDraft?.tracking_info || {})?.length === 0 && Object.keys(trainingDraft?.level_completion)?.length === 0);
        if (trainingData?.settings?.section_restricted) {
            return trainingDraft?.level_completion?.section_id?.includes(sId.toString())
                || trainingDraft?.tracking_info?.last_section_id?.toString() === sId?.toString()
                || isCompleted || firstSection;
        }
        return true;
    };

    const saveTrackingInfo = (sectionId, subSectionId) => {
        const data = {};
        data.level_completion = trainingDraft?.level_completion;
        data.tracking_info = {
            last_section_id: sectionId,
            last_content_id: subSectionId
        };
        if (isFromTraningView) {
            actiontTrainingDraft(params?.trainingId);
            if (isPublic) {
                history.push(
                    `/lms/start/training/${params?.backendId}/${params.airportCode.toUpperCase()}/${params.trainingId}/${sectionId
                    }/${subSectionId}`
                );
            } else if (manageSectionRestricted(sectionId)) {
                history.push(
                    TRAINING_MANAGEMENT_SECTION_DETAILS
                    + trainingId
                    + '/'
                    + sectionId
                    + '/'
                    + subSectionId
                );
            } else {
                setOpenAlert(true);
            }
        } else if (data?.level_completion?.content_id === undefined || !data?.level_completion?.content_id?.includes(String(params.subId))) {
            if (manageSectionRestricted(sectionId)) {
                showAlert();
            } else {
                setOpenAlert(true);
            }
        } else if (props.match.path.includes('auth')) {
            actiontTrainingDraft(params?.trainingId);
            history.push(
                '/auth/adp/training/section/start/'
                +trainingId
                +'/'
                +sectionId
                +'/'
                +subSectionId
            );
            setOpen(false);
        } else {
            actiontTrainingDraft(params?.trainingId);
            if (isPublic) {
                history.push(
                    `/lms/start/training/${params?.backendId}/${params.airportCode.toUpperCase()}/${params.trainingId}/${sectionId
                    }/${subSectionId}`
                );
            } else if (manageSectionRestricted(sectionId)) {
                history.push(
                    TRAINING_MANAGEMENT_SECTION_DETAILS
                    + trainingId
                    + '/'
                    + sectionId
                    + '/'
                    + subSectionId
                );
            } else {
                setOpenAlert(true);
            }
        }
        setSectionId(sectionId);
        setSubId(subSectionId);
        if (setPlaybackTimeSet) {
            setPlaybackTimeSet(true);
        }
    };

    const goToNextModule = () => {
    if (props.match.path.includes('auth')) {
        actiontTrainingDraft(params?.trainingId);
        history.push(
            '/auth/adp/training/section/start/'
            +trainingId
            +'/'
            +section_Id
            +'/'
            +subSectcion_Id
        );
        setOpen(false);
    } else {
        if (isPublic) {
            const data = {};
            const quizzArray = trainingData?.sections?.map((obj, index) => ({
                id: obj.id,
                attempts: trainingDraft?.tracking_info?.attempts_used?.[index]?.attempts || 1,
                total_reattempts: Number(trainingData?.sections[index].additional_config?.no_of_quiz_reattempts) || 1,
                total_days: Number(trainingData?.sections[index].additional_config?.no_of_days_to_mandate) || 1,
                reattempts_failure_days: Number(trainingData?.sections[index].additional_config?.no_of_days_to_mandate_for_reattempts_failure)|| 1,
                attempt_date: trainingDraft?.tracking_info?.attempts_used?.[index]?.attempt_date || new Date(),
                type: trainingData?.sections[index]?.additional_config?.whenQuizFail,
                final_result: trainingDraft?.tracking_info?.attempts_used?.[index]?.final_result,
                current_attempt_result: trainingDraft?.tracking_info?.attempts_used?.[index]?.current_attempt_result?.length > 0
                    && trainingDraft?.tracking_info?.attempts_used?.[index]?.current_attempt_result === 'fail' ? 'fail' : '',
                index,
                quizDraft: trainingDraft?.tracking_info?.attempts_used?.[index]?.quizDraft || {},
                shuffleQuiz: trainingDraft?.tracking_info?.attempts_used?.[index]?.shuffleQuiz || []
            }));
            data.tracking_info = {
                last_content_id: subSectionId,
                last_section_id: sectionId,
                last_page_number: 1,
                attempts_used: quizzArray
            };
            actionContentInfo(params.trainingId, data);
            history.push(
                `/lms/start/training/${params?.backendId}/${params.airportCode.toUpperCase()}/${params.trainingId}/${sectionId
                }/${subSectionId}`
            );
        } else {
            const data = {};
            const quizzArray = trainingData?.sections?.map((obj, index) => ({
                id: obj.id,
                attempts: trainingDraft?.tracking_info?.attempts_used?.[index]?.attempts || 1,
                total_reattempts: Number(trainingData?.sections[index].additional_config?.no_of_quiz_reattempts) || 1,
                total_days: Number(trainingData?.sections[index].additional_config?.no_of_days_to_mandate) || 1,
                reattempts_failure_days: Number(trainingData?.sections[index].additional_config?.no_of_days_to_mandate_for_reattempts_failure)|| 1,
                attempt_date: trainingDraft?.tracking_info?.attempts_used?.[index]?.attempt_date || new Date(),
                type: trainingData?.sections[index]?.additional_config?.whenQuizFail,
                final_result: trainingDraft?.tracking_info?.attempts_used?.[index]?.final_result,
                current_attempt_result: trainingDraft?.tracking_info?.attempts_used?.[index]?.current_attempt_result?.length > 0
                    && trainingDraft?.tracking_info?.attempts_used?.[index]?.current_attempt_result === 'fail' ? 'fail' : '',
                index,
                quizDraft: trainingDraft?.tracking_info?.attempts_used?.[index]?.quizDraft || {},
                shuffleQuiz: trainingDraft?.tracking_info?.attempts_used?.[index]?.shuffleQuiz || []
            }));
            data.tracking_info = {
                last_content_id: subSectionId,
                last_section_id: sectionId,
                last_page_number: 1,
                attempts_used: quizzArray
            };
            actionContentInfo(params.trainingId, data);
            history.push(
                TRAINING_MANAGEMENT_SECTION_DETAILS
                + trainingId
                + '/'
                + section_Id
                + '/'
                + subSectcion_Id
            );
        }
        setOpen(false);
    }
      };

    let quizId = Number(params.subId);

    let CheckQuizStatus = (section) => {
        let res = trainingDraft?.quiz_ans?.filter((ele) => {
            if (ele.schema.id === section.quiz.id && ele.section_id === section.id.toString()) {
                return ele;
            } else { return null; }
        });
        if (!trainingDraft) {
            return false;
        }
        if (res?.length === 0) {
            return false;
        } else {
            return true;
        }
    };

    useEffect(() => {
        if (!flag) {
            actiontTrainingDraft(params?.trainingId);
            setFlag(true);
        }
    }, [actiontTrainingDraft, params, flag]);

    return (
        <div className={styles.trainingHeader + ' ' + styles.mainblock} style={{ height: toggle ? '100vh' : '' }}>
            <div
                className={
                    isFromTraningView
                        ? 'd-flex justify-content-between align-items-center'
                        : styles.headerData
                }
            >
                <div
                    className={styles.contentHeader}
                >
                    <h2>Training Content</h2>
                    {isPublic && !margin && trainingData?.status === 'active' && Object.keys(trainingDraft?.level_completion)?.length === 0 && (
                        <Button
                            translationID="training.start.training"
                            defaultText="Start"
                            onClick={() => startTraining('scratch')}
                        />
                    )}
                </div>
            </div>
            <div>
                {totalSections > 0
                && trainingData?.sections?.map(section => (
                            <Collapsible
                            autoheight={false}
                            openOnMount={section.id === parseInt(sectionId, 10)}
                            key={section.name}
                            titleNode={
                                <>
                                    <span className={styles.sectionText} key={section.id}>
                                        {section.name}
                                    </span>
                                </>
                            }
                            styleClasses={styles.sectionCollaps}
                        >
                            {section.contents.sort((a, b) => a.index - b.index).map(item => (
                                    <div
                                        className={classnames(
                                            styles.sectionItem,
                                            subSectionId === item.id
                                            && !isFromTraningView
                                            && section.id === parseInt(sectionId, 10)
                                                ? styles.mainSection
                                                : ''
                                        )}
                                        key={item.id}
                                    >
                                        <div
                                            className={classnames(
                                                styles.sectionContent,
                                                item.isStarted ? styles.activeSection : '',
                                                !isFromTraningView ? styles.sectionWrap : ''
                                            )}
                                            onClick={() => {
                                                if (quizId === section?.quiz?.id && section?.additional_config?.content_restricted === true) {
                                                    return;
                                                }
                                                saveTrackingInfo(section.id, item.id);
                                            }}
                                        >
                                            <div
                                                className={classnames(
                                                    checkContentIsCompleted(section.id, item.id)
                                                        ? styles.checkIconColor
                                                        : '',
                                                    styles.iconWrap
                                                )}
                                            >
                                                {checkContentIsCompleted(section.id, item.id) ? (
                                                    <CheckCircle />
                                                ) : (
                                                    item.file_name ? (
                                                        item.file_name?.split('.').pop() === 'pdf' ? (
                                                            <MenuBookRounded />
                                                        ) : (
                                                            item.file_name?.split('.').pop() === 'mp4'
                                                            || item.file_name?.split('.').pop() === 'mp3' ? (
                                                                <PlayCircleOutlineOutlined />
                                                            ) : (
                                                                <MenuBookRounded />
                                                            )
                                                        )
                                                    )
                                                    : (
                                                        !item?.schema ? <PlayCircleOutlineOutlined /> : (
                                                            <div
                                                                className={(quizId === section.quiz.id && section.id === parseInt(sectionId, 10)) ? styles.displayBar : ''}
                                                                style={{ cursor: 'pointer' }}>
                                                                <div className={quizId === section.quiz.id ? styles.bar : ''}></div>
                                                                <div
                                                                    style={{ marginLeft: margin !== undefined ? '0.5%' : '', marginBottom: margin !== undefined ? '4%' : '2%', whiteSpace: 'pre' }}
                                                                    className={`${quizId === section.quiz.id ? styles.iconMargin : ''} ${styles.quiz}`}
                                                                    onClick={() => { saveTrackingInfo(section.id, section.quiz.id, 'quiz'); }}
                                                                >
                                                                    <LibraryAddCheckIcon style={{ color: CheckQuizStatus(section) ? 'rgb(166,229,15)' : '' }} fontSize="medium" />
                                                                    {section?.quiz?.title}
                                                                </div>
                                                            </div>
                                                        )
                                                    )
                                                )}
                                            </div>
                                            {!isFromTraningView && !item?.schema && (
                                                <div
                                                    className={!isFromTraningView ? styles.titleWrap : ''}
                                                >
                                                    <h4>{item.name || item.file_name || item.title}</h4>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </Collapsible>
                    ))}
            </div>
            <>
                <Modal showIn={open} onClose={() => { setOpen(false); }} width="300px" minHeight="auto">
                {/* headder */}
                <div className={styles.headder}>
                    <h3 className={styles.alertText}><FormattedMessage id="alert" defaultMessage="Alert" /></h3>
                </div>
                {/* body */}
                <div className={styles.body}>
                    <FormattedMessage id="training.alert.complete.module" defaultMessage="Are you sure you want to continue without completing current module?" />
                </div>
                {/* footer */}
                <div className={styles.footer}>
                    <Button
                        className={styles.cancleBtn}
                        translationID="training.module.cancel"
                        defaultText="Cancel"
                        onClick={() => { setOpen(false); }}
                    />
                    <Button
                        className={styles.nextBtn}
                        translationID="training.module.next"
                        defaultText="Continue"
                        onClick={() => { goToNextModule(); }}
                    />
                </div>
                </Modal>
            </>
            <Modal showIn={openAlert} onClose={() => { setOpenAlert(false); }} width="300px" minHeight="auto">
                {/* headder */}
                <div className={styles.headder}>
                    <h3 className={styles.alertText}>
                        <FormattedMessageWithClass id="alert" defaultMessage="Alert" />
                    </h3>
                </div>
                {/* body */}
                <div className={styles.body}>
                    <FormattedMessageWithClass
                        id="lms.alert.section.restricted"
                        defaultMessage="This section is locked. Please complete the previous section to continue."
                    />
                </div>
                {/* footer */}
                <div className={styles.footer}>
                    <Button
                        className={styles.cancleBtn}
                        translationID="sms.form.cancel"
                        defaultText="Cancel"
                        onClick={() => { setOpenAlert(false); }}
                    />
                </div>
            </Modal>
        </div>
    );
}

export default SectionsList;
